import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Paper,
  Container,
  Divider,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay/PickersDay';
import Happymood from '../../../src/assets/images/happy-img.svg';
import Allmood from '../../../src/assets/images/mood-img/All.svg';
import Calmmood from '../../../src/assets/images/Calm.svg';
import Excitedmood from '../../../src/assets/images/Excitedmood.svg';
import Worriedmood from '../../../src/assets/images/Worried.svg';
import Angrymood from '../../../src/assets/images/Angry.svg';
import Scaredmood from '../../../src/assets/images/Scared.svg';
import Confidentmood from '../../../src/assets/images/Confident.svg';
import Annoyedmood from '../../../src/assets/images/Annoyed.svg';
import ActivitiesIcon from '../../../src/assets/images/activities-icon.svg';
import { insightsViewModel } from '../views/dashboard/insights.view.model';
import { Image } from 'react-bootstrap';
import {
  ANGRY,
  ANNOYED,
  CALM,
  CONFIDENT,
  EXCITED,
  HAPPY,
  SCARED,
  WORRIED,
  ALLMOOD,
} from '../../constants/moodType.constants';
import './binkiesCompliments.css';
import EventsDropdown from './EventsDropdown';
import CalendarRightSection from './CalendarRightSection';
import { notesViewModel } from '../views/school/notes.view.model';
import {
  ADD_TWENTY_MINUTE_PROMISE_ROUTE,
  EDIT_TWENTY_MINUTE_PROMISE_ROUTE,
  NOTES,
} from '../../constants/routes.constants';
import { useHistory } from 'react-router-dom';
import { specialCampViewModel } from '../views/special_camp/special.camp.viewmodel';
import RoundButton from '../common/RoundButton';
import { campScheduleViewModel } from '../views/camp_schedule/camp.schedule.view.model';
import { useAuth } from '../auth/Auth';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: '#fff',
    boxShadow: 'none',
    padding: '0px !important',
  },
  avatar: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  dsl: {
    backgroundColor: 'red',
  },
  selectedDay: {
    backgroundColor: '#ffeb3b', // Highlight color
    color: '#000', // Text color for highlighted days
  },
  icon: {
    paddingLeft: '15px',
    // paddingBottom: '5px'
  },
  header: {
    padding: '15px 22px',
    background: '#321B6D',
    // backgroundImage: linear - gradient(to right top, #6134d3, #5329bc, #49279f, #3d2185, #321b6d);
    borderRadius: '18px 18px 0px 0px',
  },
  ToggleButton: {
    border: 'none !important',
    padding: '7px !important',
    backgroundColor: 'transparent !important',
  },
  calendarDiv1: {
    width: '50%',
    minWidth: '50%',
    alignItems: 'center',
    marginBottom: 'auto !important',
    marginTop: 'auto !important',
  },
  viewNotes: {
    padding: '25px',
    color: '#0066FF',
    display: 'flex',
    justifyContent: 'end',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  calendarTopSection: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

const returnMonth = (date) => {
  const newDate = new Date(date);
  return newDate.getMonth() + 1;
};

function ServerDay(props) {
  const {
    highlightedDaysData = [],
    highlightedDaysCreativeData = [],
    highlightedDaysFeelingData = [],
    highlightedDaysNotesData = [],
    highlightedDaysSpecialData = [],
    day,
    outsideCurrentMonth,
    mood,
    setSelectedDate,
    selectedEvent,
    ...other
  } = props;
  const weekDays = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];
  const convertDate = (data) => {
    const date = new Date(data);
    return date;
  };
  const isSelected =
    selectedEvent === 1
      ? !outsideCurrentMonth &&
        highlightedDaysFeelingData.findIndex(
          (item) =>
            Number(item?.day) === day.getDate() &&
            Number(item?.month) === day.getMonth() + 1
        ) !== -1
      : selectedEvent === 4
      ? !outsideCurrentMonth &&
        highlightedDaysNotesData.findIndex(
          (item) =>
            convertDate(item?.created_at).getDate() === day.getDate() &&
            returnMonth(item?.created_at) === day.getMonth() + 1
        ) !== -1
      : selectedEvent === 2
      ? !outsideCurrentMonth &&
        highlightedDaysData[0] === weekDays[day.getDay()]
      : selectedEvent === 3
      ? !outsideCurrentMonth &&
        highlightedDaysData.findIndex(
          (item) => Number(item) === day.getDate()
        ) !== -1
      : selectedEvent === 5
      ? !outsideCurrentMonth &&
        highlightedDaysData[0] === weekDays[day.getDay()]
      : false;
  const isSelectedMood = isSelected
    ? selectedEvent === 1
      ? mood === 'All'
        ? highlightedDaysFeelingData[
            highlightedDaysFeelingData.findIndex(
              (item) => Number(item?.day) === day.getDate()
            )
          ]?.mood
        : highlightedDaysFeelingData[
            highlightedDaysFeelingData.findIndex(
              (item) =>
                Number(item?.day) === day.getDate() && item?.mood === mood
            )
          ]?.mood
      : selectedEvent === 4
      ? 'notes'
      : selectedEvent === 2
      ? 'creative-camp'
      : selectedEvent === 3
      ? 'special-camp'
      : selectedEvent === 5
      ? 'twenty-min-promise'
      : ''
    : '';

  const handleSelect = () => {
    setSelectedDate(day.getDate());
    setTimeout(() => {
      setSelectedDate(null); // Directly clear after 3 seconds
    }, 2000);
  };

  return (
    <PickersDay
      {...other}
      outsideCurrentMonth={outsideCurrentMonth}
      day={day}
      className={
        isSelected ? `selected-day-${isSelectedMood}` : 'no-selected-day'
      }
      onClick={handleSelect}
    />
  );
}

const MoodTracker = ({ dependent }) => {
  const classes = useStyles();
  const currentDate = new Date();
  const history = useHistory();
  const { guardian } = useAuth();
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedMonth, setSelectedMonth] = React.useState(
    currentDate.getMonth() + 1
  );
  const [selectedYear, setSelectedYear] = React.useState(
    currentDate.getFullYear()
  );
  const [selected, setSelected] = React.useState(new Date());
  const [highlightedDays, setHighlightedDays] = React.useState([]);
  const [highlightedFeelingDays, setHighlightedFeelingDays] = React.useState(
    []
  );
  const [highlightedNotesDays, setHighlightedNotesDays] = React.useState([]);
  const [highlightedDaysData, setHighlightedDaysData] = React.useState([]);
  const [highlightedDaysFeelingData, setHighlightedDaysFeelingData] =
    React.useState([]);
  const [highlightedDaysCreativeData, setHighlightedDaysCreativeData] =
    React.useState([]);
  const [highlightedDaysSpecialData, setHighlightedDaysSpecialData] =
    React.useState([]);
  const [highlightedDaysNotesData, setHighlightedDaysNotesData] =
    React.useState([]);
  const [mood, setMood] = React.useState('All');
  const [avatarClass, setAvatarClass] = React.useState('');
  const [selectedEvent, setSelectedEvent] = React.useState(1);
  const [twentyMinPromise, setTwentyMinPromise] = useState([]);
  const [isPromiseLoading, setIsPromiseLoading] = useState(false);
  const [notes, setNotes] = React.useState([]);
  const eventList = [
    { id: 1, name: 'Feelings & Thoughts' },
    { id: 2, name: 'Creative Camps' },
    { id: 3, name: 'Dream Camps' },
    { id: 4, name: 'Notes' },
    { id: 5, name: '20 min promise' },
  ];
  const [query, setQuery] = React.useState({
    dependent_id: dependent.id,
    month: selected.getMonth() + 1,
    year: selected.getFullYear(),
  });

  const handleDateChange = (date) => {
    // console.log(date)
  };

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
    setSelected(month);
    setSelectedDate(null);
  };

  const handleYearChange = (year) => {
    setSelectedYear(year);
    setSelected(year);
  };

  const handleMoodChange = (event, newMood) => {
    if (newMood !== null) {
      if (newMood === 'All') {
        onAllClick();
      } else {
        setMood(newMood);
      }
    }
  };

  const onAllClick = () => {
    setMood('All');
  };

  const getMood = () => {
    if (
      highlightedDaysFeelingData.findIndex(
        (item) => Number(item.month) === selected.getMonth() + 1
      ) === -1
    ) {
      const data = {
        dependent_id: dependent?.id,
        year: selected.getFullYear(),
        month: selected.getMonth() + 1,
        mood: '',
      };
      let tempArray = [];
      insightsViewModel
        .getKidMood(data)
        .then((res) => {
          if (res?.data.length) {
            setHighlightedFeelingDays(
              res?.data.map((item, i) => {
                return Number(item.day);
              })
            );
            setHighlightedDaysFeelingData((prevData) => [
              ...prevData,
              ...res?.data,
            ]);
          } else {
            setHighlightedFeelingDays([]);
            setHighlightedDaysFeelingData([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getDependentNotes = () => {
    if (
      highlightedDaysNotesData.findIndex(
        (item) => returnMonth(item?.created_at) === selected.getMonth() + 1
      ) === -1
    ) {
      const list = [];
      const params = { ...query };
      params.month = selected.getMonth() + 1;
      params.year = selected.getFullYear();
      notesViewModel
        .getDependentNotesByMonth(params, dependent?.id, list)
        .then((res) => {
          setNotes(res.commentList);
          if (res?.commentList?.length) {
            setHighlightedNotesDays(
              res?.commentList.map((item, i) => {
                let date = new Date(item?.created_at);
                return date.getDate();
              })
            );
            setHighlightedDaysNotesData((prevData) => [
              ...prevData,
              ...res?.commentList,
            ]);
          } else {
            setHighlightedNotesDays([]);
            setHighlightedDaysData([]);
          }
        })
        .catch((error) => {
          console.log(error);
          setHighlightedNotesDays([]);
          setHighlightedDaysData([]);
        });
    }
  };

  const setSelectedMoodClass = () => {
    switch (mood) {
      case HAPPY:
        setAvatarClass('happy-mood');
        break;
      case EXCITED:
        setAvatarClass('excited-mood');
        break;
      case CALM:
        setAvatarClass('calm-mood');
        break;
      case WORRIED:
        setAvatarClass('worried-mood');
        break;
      case ANGRY:
        setAvatarClass('angry-mood');
        break;
      case SCARED:
        setAvatarClass('scared-mood');
        break;
      case CONFIDENT:
        setAvatarClass('confident-mood');
        break;
      case ANNOYED:
        setAvatarClass('annoyed-mood');
        break;
      case ALLMOOD:
        setAvatarClass('all-mood');
        break;
      default:
        break;
    }
  };

  const getCreativeCamp = () => {
    setHighlightedDays([dependent?.profile?.group?.day]);
    setHighlightedDaysData([dependent?.profile?.group?.day]);
  };
  // const getSpecialCamps = () => {
  //   specialCampViewModel
  //     .getDependentMultiSpecialCamps(dependent.id)
  //     .then((res) => {
  //       setSpecialCamp(res);
  //     })
  //     .catch((err) => {});
  // };
  const getSpecialCamp = () => {
    if (dependent?.id) {
      const params = {
        month: selected.getMonth() + 1,
        year: selected.getFullYear(),
      };
      specialCampViewModel
        .getDependentMultiSpecialCamps(dependent?.id, params)
        .then((res) => {
          if (res) {
            const dayNumbers = res
              .map((item) => new Date(item.end_date_time))
              .map((date) => date.getDate());
            setHighlightedDays(dayNumbers);
            setHighlightedDaysData(dayNumbers);
          } else {
            setHighlightedDays([]);
            setHighlightedDaysData([]);
          }
        })
        .catch((err) => {
          setHighlightedDays([]);
          setHighlightedDaysData([]);
        });
    } else {
      setHighlightedDays([]);
      setHighlightedDaysData([]);
    }
  };

  const getTwentyMinPromise = () => {
    setIsPromiseLoading(true);
    campScheduleViewModel
      .getTwentyMinPromise(dependent?.id)
      .then((res) => {
        setTwentyMinPromise(res);
        if (res.length > 0) {
          setHighlightedDays([res[0]?.day]);
          setHighlightedDaysData([res[0]?.day]);
        } else {
          setHighlightedDays([]);
          setHighlightedDaysData([]);
        }
        setIsPromiseLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsPromiseLoading(false);
      });
  };

  const getData = () => {
    if (selectedEvent === 1) {
      if (
        highlightedDaysFeelingData[0]?.dependent?.id &&
        highlightedDaysFeelingData[0]?.dependent?.id === dependent?.id
      ) {
        getMood();
      } else {
        setHighlightedFeelingDays([]);
        setHighlightedDaysFeelingData([]);
        getMood();
      }
    }
    if (selectedEvent === 2) getCreativeCamp();
    if (selectedEvent === 3) getSpecialCamp();
    if (selectedEvent === 4) getDependentNotes();
    if (selectedEvent === 5) getTwentyMinPromise();
    setSelectedMoodClass();
  };

  useEffect(() => {
    // setHighlightedDays([])
    // setHighlightedDaysData([])
    getData();
  }, [dependent, selected, mood, selectedEvent]);

  useEffect(() => {
    setHighlightedDays([]);
    setHighlightedFeelingDays([]);
    setHighlightedNotesDays([]);
    setHighlightedDaysData([]);
    setHighlightedDaysFeelingData([]);
    setHighlightedDaysNotesData([]);
    // getData()
  }, [dependent]);

  const options = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };
  const getMoodReasonComment = () => {
    const comment =
      highlightedDaysFeelingData[
        highlightedDaysFeelingData.findIndex(
          (item) => Number(item.day) === selectedDate
        )
      ]?.comment;
    return comment;
  };

  const handleViewNotesClick = () => {
    history.push({
      pathname: NOTES,
      state: {
        dependent: JSON.stringify(dependent),
      },
    });
  };

  const handleEditMinPromise = () => {
    history.push({
      pathname: EDIT_TWENTY_MINUTE_PROMISE_ROUTE,
      state: {
        promise_data: JSON.stringify(twentyMinPromise[0]),
      },
    });
  };

  const getTopRightSection = () => {
    switch (selectedEvent) {
      case 1:
        return (
          <ToggleButtonGroup
            value={mood}
            exclusive
            onChange={handleMoodChange}
            aria-label="mood"
            sx={{ ml: 2 }}
          >
            <ToggleButton
              value={'All'}
              aria-label="all"
              className={`emotion-icon ${classes.ToggleButton}`}
            >
              <Image src={Allmood} className="all" />
            </ToggleButton>
            <ToggleButton
              value={HAPPY}
              aria-label="happy"
              className={`emotion-icon ${classes.ToggleButton}`}
            >
              <Image src={Happymood} className="happy" />
            </ToggleButton>
            <ToggleButton
              value={EXCITED}
              aria-label="excited"
              className={`emotion-icon ${classes.ToggleButton}`}
            >
              <Image src={Excitedmood} className="excited" />
            </ToggleButton>
            <ToggleButton
              value={CALM}
              aria-label="calm"
              className={`emotion-icon ${classes.ToggleButton}`}
            >
              <Image src={Calmmood} className="calm" />
            </ToggleButton>
            <ToggleButton
              value={ANNOYED}
              aria-label="annoyed"
              className={`emotion-icon ${classes.ToggleButton}`}
            >
              <Image src={Annoyedmood} className="annoyed" />
            </ToggleButton>
            <ToggleButton
              value={CONFIDENT}
              aria-label="confident"
              className={`emotion-icon ${classes.ToggleButton}`}
            >
              <Image src={Confidentmood} className="confident" />
            </ToggleButton>
            <ToggleButton
              value={SCARED}
              aria-label="scared"
              className={`emotion-icon ${classes.ToggleButton}`}
            >
              <Image src={Scaredmood} className="scared" />
            </ToggleButton>
            <ToggleButton
              value={ANGRY}
              aria-label="angry"
              className={`emotion-icon ${classes.ToggleButton}`}
            >
              <Image src={Angrymood} className="angry" />
            </ToggleButton>
            <ToggleButton
              value={WORRIED}
              aria-label="worried"
              className={`emotion-icon ${classes.ToggleButton}`}
            >
              <Image src={Worriedmood} className="worried" />
            </ToggleButton>
          </ToggleButtonGroup>
        );

      case 2:
        break;

      case 3:
        break;

      case 4:
        if (
          dependent?.subscriptions?.nickname === 'Villagers' ||
          dependent?.subscriptions?.nickname === 'Branches'
        ) {
          return (
            <Typography
              className={classes.viewNotes}
              onClick={handleViewNotesClick}
            >
              View Notes
            </Typography>
          );
        } else {
          return '';
        }

      case 5:
        return (
          !isPromiseLoading &&
          guardian &&
          twentyMinPromise.length > 0 && (
            <div className="twenty-min-promise-top-button-wrapper">
              <RoundButton
                type="button"
                label="Edit Date & Time"
                className="transparent-button d-sm-block notes-top-btn"
                onClick={handleEditMinPromise}
              />
            </div>
          )
        );

      default:
        break;
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Container className={classes.root}>
        <Box
          className={classes.header}
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Typography
            variant="h6"
            className="compliments-received feeling-thoughts"
          >
            <img
              src={ActivitiesIcon}
              alt="Comment Icon"
              className={classes.icon}
            />
            {dependent?.username}'s Activities & Events
          </Typography>

          <Typography
            className="day-date"
            variant="body2"
            style={{ marginRight: '10px', fontSize: '16px', color: '#321B6D' }}
            color="#321B6D"
          >
            {currentDate.toLocaleDateString('en-GB', options)}
          </Typography>
        </Box>
        <Box
          className="moods-div"
          display="flex"
          justifyContent="end"
          alignItems="center"
          mb={3}
        >
          <div className={`event-dropdown ${classes.calendarTopSection}`}>
            <Box
              className="thoughts-box-div calendar-main"
              mt={3}
              display="flex"
              alignItems="center"
            >
              <Box className="thoughts-box" ml={2}>
                <EventsDropdown
                  selectedEvent={selectedEvent}
                  setSelectedEvent={setSelectedEvent}
                  eventList={eventList}
                />
              </Box>
            </Box>
          </div>

          <div className={classes.calendarTopSection}>
            {getTopRightSection()}
          </div>
        </Box>
        <Paper
          className="calendardiv full_width_calendar"
          elevation={3}
          sx={{ p: 2 }}
        >
          <DateCalendar
            className={`full_calendar ${classes.calendarDiv1}`}
            // defaultValue={currentDate}
            onChange={handleDateChange}
            onMonthChange={handleMonthChange}
            onYearChange={handleYearChange}
            views={['month', 'day']}
            slots={{
              day: ServerDay,
            }}
            slotProps={{
              day: {
                highlightedDaysData,
                highlightedDaysCreativeData,
                highlightedDaysFeelingData,
                highlightedDaysNotesData,
                highlightedDaysSpecialData,
                mood: mood,
                setSelectedDate: setSelectedDate,
                selectedEvent: selectedEvent,
              },
            }}
          />
          <Box
            sx={{
              width: '2px',
              height: '440px',
              backgroundColor: '#DFE0EB',
              margin: '0 20px',
            }}
            className="mobile-none tablet_none"
          />
          <CalendarRightSection
            dependent={dependent}
            selectedDate={selectedDate}
            highlightedDays={highlightedDays}
            highlightedFeelingDays={highlightedFeelingDays}
            highlightedNotesDays={highlightedNotesDays}
            highlightedDaysData={highlightedDaysData}
            highlightedDaysFeelingData={highlightedDaysFeelingData}
            highlightedDaysNotesData={highlightedDaysNotesData}
            getMoodReasonComment={getMoodReasonComment}
            avatarClass={avatarClass}
            selectedEvent={selectedEvent}
            getDependentNotes={getDependentNotes}
            mood={mood}
            isPromiseLoading={isPromiseLoading}
            twentyMinPromise={twentyMinPromise}
          />
        </Paper>
      </Container>
    </LocalizationProvider>
  );
};

export default MoodTracker;
